"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var PageWidth = function PageWidth(_ref) {
  var formProps = _ref.formProps;
  var setPageWidth = function setPageWidth(pageWidth) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, {
        pageWidth: pageWidth
      })
    }));
  };
  var currentValue = formProps.values.courseDescription && formProps.values.courseDescription.pageWidth;
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "Page Width"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "btn-group ".concat(_style["default"].pageWidthButtons),
    role: "group"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn ".concat(currentValue === 'small' ? 'btn-primary' : 'btn-default'),
    onClick: function onClick() {
      return setPageWidth('small');
    }
  }, "Small"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn ".concat(currentValue === 'medium' ? 'btn-primary' : 'btn-default'),
    onClick: function onClick() {
      return setPageWidth('medium');
    }
  }, "Medium"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn ".concat(currentValue === 'large' ? 'btn-primary' : 'btn-default'),
    onClick: function onClick() {
      return setPageWidth('large');
    }
  }, "Large")));
};
var _default = PageWidth;
exports["default"] = _default;